<template>
  <div class="horoscope_result">
    <section class="text_center" v-if="horoscope != null">
      <div class="horoscope_result_box">
        <img src="/assets/img/horoscope/title.png" alt="本日の運勢結果" class="title" />
        <div class="horoscope_result_flex_wrap">
          <div class="horoscope_result_flex" v-html="getImages('total', horoscope.total_rate)"></div>
          <div class="horoscope_result_flex" v-html="getImages('love', horoscope.love_rate)"></div>
          <div class="horoscope_result_flex" v-html="getImages('money', horoscope.money_rate)"></div>
          <div class="horoscope_result_flex" v-html="getImages('job', horoscope.job_rate)"></div>
        </div>
        <p class="text_left">{{ horoscope.content }}</p>
      </div>
      <p><router-link to="/" class="arrow link_main--text">トップページへ戻る</router-link></p>
    </section>
    <section v-else-if="errors.length > 0" class="horoscope_unregistered text_center">
      <p v-for="(entry, index) in errors" :key="index">{{ entry }}</p>
      <p><router-link :to="{ name: 'UserProfileChange' }" class="arrow link_main--text">生年月日を登録する</router-link></p>
    </section>
  </div>
</template>

<script>
import { GET_HOROSCOPE } from '@/store/horoscope/actions'

export default {
  name: 'HoroscopeResult',
  data () {
    return {
      errors: [],
      horoscope: null,
      totalImagePath: '<img src="/assets/img/horoscope/total.png" alt="総合" />',
      loveImagePath: '<img src="/assets/img/horoscope/love.png" alt="恋愛" />',
      moneyImagePath: '<img src="/assets/img/horoscope/money.png" alt="金運" />',
      jobImagePath: '<img src="/assets/img/horoscope/job.png" alt="仕事" />',
      totalEmptyImagePath: '<img src="/assets/img/horoscope/total_empty.png" alt="総合アイコン_空" />',
      totalHalfImagePath: '<img src="/assets/img/horoscope/total_half.png" alt="総合アイコン_半分" />',
      totalFullImagePath: '<img src="/assets/img/horoscope/total_full.png" alt="総合アイコン_全部" />',
      loveEmptyImagePath: '<img src="/assets/img/horoscope/love_empty.png" alt="恋愛_空" />',
      loveHalfImagePath: '<img src="/assets/img/horoscope/love_half.png" alt="恋愛_半分" />',
      loveFullImagePath: '<img src="/assets/img/horoscope/love_full.png" alt="恋愛_全部" />',
      moneyEmptyImagePath: '<img src="/assets/img/horoscope/money_empty.png" alt="金銭_空" />',
      moneyHalfImagePath: '<img src="/assets/img/horoscope/money_half.png" alt="金銭_半分" />',
      moneyFullImagePath: '<img src="/assets/img/horoscope/money_full.png" alt="金銭_全部" />',
      jobEmptyImagePath: '<img src="/assets/img/horoscope/job_empty.png" alt="仕事_空" />',
      jobHalfImagePath: '<img src="/assets/img/horoscope/job_half.png" alt="仕事_半分" />',
      jobFullImagePath: '<img src="/assets/img/horoscope/job_full.png" alt="仕事_全部" />'
    }
  },
  methods: {
    getHoroscope () {
      this.$store.dispatch(GET_HOROSCOPE)
        .then((data) => {
          this.horoscope = data
        })
        .catch((error) => {
          this.errors = []
          this.errors.push(error.message)
        })
    },
    getImages (type, rate) {
      const images = []
      let calcRate = rate / 10 / 2

      if (type === 'total') {
        images.push(this.totalImagePath)
      } else if (type === 'love') {
        images.push(this.loveImagePath)
      } else if (type === 'money') {
        images.push(this.moneyImagePath)
      } else if (type === 'job') {
        images.push(this.jobImagePath)
      }

      for (let i = 0; i < 5; i++) {
        if (calcRate === 0) {
          if (type === 'total') {
            images.push(this.totalEmptyImagePath)
          }
          if (type === 'love') {
            images.push(this.loveEmptyImagePath)
          }
          if (type === 'money') {
            images.push(this.moneyEmptyImagePath)
          }
          if (type === 'job') {
            images.push(this.jobEmptyImagePath)
          }
        } else if (calcRate === 0.5) {
          calcRate -= 0.5
          if (type === 'total') {
            images.push(this.totalHalfImagePath)
          }
          if (type === 'love') {
            images.push(this.loveHalfImagePath)
          }
          if (type === 'money') {
            images.push(this.moneyHalfImagePath)
          }
          if (type === 'job') {
            images.push(this.jobHalfImagePath)
          }
        } else if (calcRate >= 1) {
          calcRate -= 1
          if (type === 'total') {
            images.push(this.totalFullImagePath)
          }
          if (type === 'love') {
            images.push(this.loveFullImagePath)
          }
          if (type === 'money') {
            images.push(this.moneyFullImagePath)
          }
          if (type === 'job') {
            images.push(this.jobFullImagePath)
          }
        }
      }

      return images.join('\n')
    }
  },
  created () {
    this.getHoroscope()
  }
}
</script>
